import { NgModule } from '@angular/core';
import { NgxStarsComponent } from './ngx-stars.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    NgxStarsComponent
  ],
  exports: [
    NgxStarsComponent
  ]
})
export class NgxStarsModule { }
